import { inject, Injectable } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { combineLatest, map, Observable, take } from "rxjs";
import { ClienteContextService } from "../../context-service/cliente/cliente-context.service";
import { ModuloContextService } from "../../context-service/modulo/modulo-context.service";
import { ModuloNavigationService } from "../../../_shared/utils/ModuloNavigationService";

export const moduloRedirectGuard: CanActivateFn = (
    route,
    state
) => {

    const clienteContext = inject(ClienteContextService);
    const moduloContext = inject(ModuloContextService);
    const moduloNav = inject(ModuloNavigationService);
    const router = inject(Router);

    return combineLatest([
        clienteContext.getCliente(),
        moduloContext.getModulos()
    ]).pipe(
        take(1),
        map(([cliente, modulos]) => {

            const urlAtual = state.url.replace(/^\//, '');

            const modulo = modulos.find(m =>
                m.urlAcessoPortalTransparencia === urlAtual
            );

            if (!modulo) return true;

            const redirectUrl =
                moduloNav.resolveUrl(modulo, cliente);

            if (moduloNav.isExternal(redirectUrl)) {
                window.location.href = redirectUrl;
                return false;
            }

            if (`/${redirectUrl}` !== state.url) {
                return router.parseUrl(redirectUrl);
            }

            return true;
        })
    );
};
